import { styled } from "styled-components";

export const Main = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
`;
